export default "__VITE_ASSET__1Inwhpfa__"